import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Navbar from './components/Navbar';
import reportWebVitals from './reportWebVitals';
import Footer from './components/Footer';

// Fallback page for deep-links (only used if router doesn't render)
import Organizers from './pages/Organizers';

const root = ReactDOM.createRoot(document.getElementById('root'));

const pathname = (window.location && window.location.pathname) || '/';
const route = (pathname.replace(/\/+$/, '') || '/');

root.render(
  <React.StrictMode>
    <div className="app-container">
      <Navbar />
      <div className="content">{/* router normally renders into this */}</div>
      <Footer />
    </div>
  </React.StrictMode>
);

// ---- Fallback deep-link render (prevents duplicates) ----
if (route === '/organizers-dev') {
  // Give the existing router a moment to render first.
  setTimeout(() => {
    const container = document.querySelector('.content');
    if (!container) return;

    // Has the router already put real content inside?
    const hasContent = Array.from(container.childNodes).some(
      (n) => n.nodeType === 1 && n.tagName !== 'SCRIPT'
    );

    // If not, mount Organizers as a one-time fallback.
    if (!hasContent) {
      const fallbackRoot = ReactDOM.createRoot(container);
      fallbackRoot.render(<Organizers />);
    }
  }, 120);
}

reportWebVitals();
